// extracted by mini-css-extract-plugin
export var addButton = "_pg-0";
export var border = "_pg-8";
export var check = "_pg-h";
export var danger = "_pg-6";
export var dropdownContainer = "_pg-1";
export var editModalBody = "_pg-j";
export var footerContainer = "_pg-i";
export var fullWidth = "_pg-a";
export var hide = "_pg-9";
export var icon = "_pg-3";
export var input = "_pg-7";
export var inputFlex = "_pg-b";
export var inputWrapper = "_pg-c";
export var manualFocus = "_pg-5";
export var optionButton = "_pg-4";
export var pillWrapper = "_pg-e";
export var pointer = "_pg-2";
export var showOverflow = "_pg-f";
export var tagsFlex = "_pg-d";
export var xButton = "_pg-g";